(function() {
  'use strict';

  angular
    .module('admin.subscription.service', [])
    .factory('SubscriptionService', SubscriptionService);

  /** @ngInject */
  function SubscriptionService($http, $q, API) {
    function list(){
      var data = localStorage.getItem('collectible_subscription');
      if (data) {
        data = JSON.parse(data)
      }
      return data;
    }

    function get(id){
      var data = list();
      var item = {};
      for (var i = 0; i < data.length; i++) {
        if (data[i].id === id) {
          item = data[i];
          break;
        }
      }

      return item
    }

    function add(item){
      var data = list();
      item.n = data ? data.length + 1 : 1;
      if (data) {
        data.push(item)
      } else {
        data = [item]
      }
      localStorage.setItem('collectible_subscription', JSON.stringify(data))
      return data
    }

    function update(item){
      var data = list();
      for (var i = 0; i < data.length; i++) {
        if (data[i].id === item.id) {
          data[i] = item;
          break;
        }
      }

      localStorage.setItem('collectible_subscription', JSON.stringify(data));

      return data;
    }

    function remove(item) {
      var data = list();
      for (var i = 0; i < data.length; i++) {
        if (data[i].id === item.id) {
          data.remove(data[i])
          break;
        }
      }

      localStorage.setItem('collectible_subscription', JSON.stringify(data));

      return data;
    }

    return{
      list: list,
      get: get,
      add: add,
      update: update,
      remove: remove,
    };

  }

})();
